import { inject, Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { Uuid } from '../../../../../graphql';
import { GLOBAL_GRAPHQLGATEWAY_NAME_NO_OVERLAY } from '../../../../graphql.module';
import { CreateUserFeedback, CreateUserFeedbackVariables } from './mutation/createUserFeedback.generated';
import { SetPlanRating } from './mutation/set-rating.generated';

@Injectable({
    providedIn: 'root',
})
export class QuickFeedbackApiService {
    readonly #apollo = inject(Apollo);

    get #gql() {
        return this.#apollo.use(GLOBAL_GRAPHQLGATEWAY_NAME_NO_OVERLAY);
    }

    setFeedbackScoreForPlanAutoMeasure(score: 0 | 1, estimateId: Uuid, planId: Uuid, feedbackText: string) {
        return this.#gql.mutate({
            mutation: SetPlanRating,
            variables: {
                estimateId,
                planId,
                starRating: score,
                feedback: feedbackText,
            },
            fetchPolicy: 'no-cache',
            errorPolicy: 'all',
        });
    }

    setFeedbackInput(input: CreateUserFeedbackVariables['input']) {
        return this.#gql.mutate({
            mutation: CreateUserFeedback,
            variables: {
                input,
            },
        });
    }
}
